import { API_PUBLIC } from "../consts/apiRoutes.consts"
import SERVICE_CONSTS from "../consts/services.consts"
import { api } from "./base/api.service"

const { RESPONSE_BASIC_STRUCTURE, MESSAGES } = SERVICE_CONSTS

export const getSurveyData = async (token) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null, status: null }

  try {
    const result = await api.get(`${API_PUBLIC}/getSurveyByClient/${token}`)

    response.status = result.status
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details || "Error al obtener la encuesta"
      response.success = false
      return response
    }

    const resultJson = await result.json()
    response.result = resultJson.result
    response.success = true
    response.message = MESSAGES.SUCCESS
    return response
  } catch (error) {
    response.success = false
    response.message = error.message || "Error de red"
    return response
  }
}

export const createClientSurvey = async (data) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  try {
    const result = await api.post(`${API_PUBLIC}/createClientSurvey`, data)

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details || "Error al guardar la encuesta"
      response.success = false
      return response
    }

    const resultJson = await result.json()
    response.result = resultJson.result
    response.success = true
    response.message = MESSAGES.SUCCESS
    return response
  } catch (error) {
    response.success = false
    response.message = error.message || "Error de red"
    return response
  }
}
